<template>
  <div>
    <form
      style="width: 90%; margin-left: auto; margin-right: auto;"
      method="PATCH"
      @submit="submitReg"
    >
      <div>
        <h3 class="header_style">
          Update Billing
        </h3>
        <p>"{{ updateData.FullName }} - ({{ updateData.installationCID }})"</p>
        <hr />

        <div class="form-group row">
          <label
            class="col-lg-4 col-form-label"
            for="numberOfTimesPaymentIsMade"
            >Payment Count</label
          >
          <div class="col-lg-8">
            <input
              type="number"
              class="form-control form-control-lg"
              id="numberOfTimesPaymentIsMade"
              v-model="regParams.numberOfTimesPaymentIsMade"
              :placeholder="updateData.numbOfpayment"
            />
          </div>
        </div>

        <div class="form-group row">
          <label
            class="col-lg-4 col-form-label"
            for="monthlyRecurringChargeDate"
            >Charge date</label
          >
          <div class="col-lg-8">
            <date-picker
              v-model="regParams.monthlyRecurringChargeDate"
              id="monthlyRecurringChargeDate"
              class="date-upload"
              :placeholder="updateData.chargeDate"
              :default-value="new Date()"
              :disabled-date="disabledBeforeTodayAndAfterAWeek"
            ></date-picker>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-lg-4 col-form-label" for="monthlyCharge"
            >Monthly charge(₦)</label
          >
          <div class="col-lg-8">
            <input
              type="number"
              class="form-control form-control-lg"
              id="monthlyCharge"
              v-model="regParams.monthlyCharge"
              :placeholder="updateData.monthlyCharge"
              disabled
            />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-lg-4 col-form-label" for="duration"
            >Payment Duration (in Months)</label
          >
          <div class="col-lg-8">
            <input
              type="number"
              class="form-control form-control-lg"
              id="duration"
              v-model="regParams.duration"
              :placeholder="updateData.pDuration"
              @change="updateMonthlyCharge"
            />
          </div>
        </div>
        <hr />

        <div>
          <button
            type="submit"
            class="btn btn-info btn-block btn-lg p-signup__form-submit"
            @click="submitReg"
          >
            Update
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
/* eslint-disable */
import DatePicker from "vue2-datepicker";

var getSearchParams = k => {
  var p = {};
  var LocationAddr = window.location.toString().split("?")[1];
  LocationAddr.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(s, k, v) {
    p[k] = v;
  });
  return k ? p[k] : p;
};

export default {
  name: "billing-update",
  components: {
    DatePicker
  },
  props: ["updateData"],
  data() {
    return {
      billingSuccess: false,
      errorsResult: {},
      regParams: {
        duration: "",
        numberOfTimesPaymentIsMade: "",
        monthlyRecurringChargeDate: "",
        monthlyCharge: ""
      },

      durationMonths: [
        {
          id: 6,
          name: "6 months"
        },
        {
          id: 12,
          name: "12 months"
        },
        {
          id: 24,
          name: "24 months"
        },
        {
          id: 36,
          name: "36 months"
        },
        {
          id: 60,
          name: "60 months"
        }
      ]
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    updateMonthlyCharge() {
      let calc;
      calc = this.updateData.amounts / this.regParams.duration;
      this.regParams.monthlyCharge = Math.ceil(calc).toFixed(2);
      this.regParams.id = this.updateData.id;
    },
    validateReg() {
      var errors = [];
      for (let [field, value] of Object.entries(this.regParams)) {
        value = value + "";
        if (value !== "null" && value !== Number.isInteger(value)) {
          value = value.trim();
        }

        switch (field) {
          case "duration":
            if (value === "null" || value === "NaN") {
              errors[field] = "Duration cannot be empty.";
            }
            break;
          case "monthlyRecurringChargeDate":
            if (value === "null" || value === "") {
              errors[field] = "Monthly recurring charge date cannot be empty.";
            }
            break;
          case "numberOfTimesPaymentIsMade":
            if (value === "null" || value === "NaN") {
              errors[field] = "Payment Installment cannot be empty.";
            }
            break;
          case "monthlyCharge":
            if (value === "null" || value === "NaN") {
              errors[field] = "Monthly charge cannot be empty.";
            }
            break;
          default:
            break;
        }
      }
      this.errorsResult = errors;
    },
    submitReg(e) {
      e.preventDefault();
      const keys = Object.keys(this.regParams);
      keys.forEach((key, index) => {
        if (key !== "monthlyRecurringChargeDate") {
          this.regParams[key] = parseInt(this.regParams[key]);
        } else {
          this.regParams[monthlyRecurringChargeDate] = this.regParams[
            monthlyRecurringChargeDate.toString()
          ];
        }
      });

      this.validateReg();
      var errorLength = Object.keys(this.errorsResult).length;
      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        setTimeout(() => {
          this.displayError = false;
        }, 3000);
        var errorMsg = Object.values(this.errorsResult).join("<br>");
        this.showErrorMsg({
          message: errorMsg
        });

        return;
      }

      const HTTP = this.$httpUtils.instance;
      const url = `/billings/${this.updateData.id}`;
      HTTP.patch(url, this.regParams)
        .then(res => {
          this.showSuccessMsg({ message: "Device Updated!" });
          location.reload();
        })
        .catch(error => {
          this.showErrorMsg({ message: error.response.data.error.message });
        });
    }
  },
  mounted() {}
};
</script>

<style scoped>
.row {
  margin-bottom: 20px;
}
h3.header_style {
  font-weight: 600;
  font-size: 24px;
  text-align: left;
}
.form-group label {
  font-size: 14px;
  color: #606266;
}
.date-upload {
  background: transparent;
  border-radius: 3px;
  border: none;
  width: 100%;
  height: 50px;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
}
.p-signup__form-submit {
  margin-bottom: 30px;
}
.p-signup__form-submit {
  margin-bottom: 30px;
}
.uk-offcanvas-bar {
  width: 90vw !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/users/BillingUpdate.vue